import Countdown from "./Countdown";
import "./style.scss";

export default function HeaderBanner() {
  return (
    <div
      className="main-banner wow fadeIn"
      id="top"
      data-wow-duration="1s"
      data-wow-delay="0.5s"
    >
      <div className="hero-banner"></div>

      {/* <div id="countdown">
        <span id="days"></span> Days
        <span id="hours"></span> Hours
        <span id="minutes"></span> Minutes
        <span id="seconds"></span> Seconds
      </div> */}

      {/* <section className="countdown-strip">
        <div id="countdown">
          <strong>ACTnet Event Starts In: </strong>
          <span id="days"></span> Days
          <span id="hours"></span> Hours
          <span id="minutes"></span> Minutes
          <span id="seconds"></span> Seconds
        </div>
      </section> */}
      <Countdown />

      <div className="container">
        <div className="row">
          {/* <div className="col-lg-12">
            <div
              className="right-image wow fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.5s"
            >
              <img src="assets/images/banner-actnet.png" alt="team meeting" />
            </div>
          </div> */}
          <div className="col-lg-12">
            <div className="row pt-5 mt-5">
              <div className="col-lg-6 text-start">
                <div
                  className="left-content header-text wow fadeInLeft"
                  data-wow-duration="1s"
                  data-wow-delay="1s"
                >
                  <h6>Event Description</h6>
                  <h2>
                    Where <em className="text-danger">Fire</em> Meets{" "}
                    <span className="text-info">Ice</span>, and Ideas Flow Like{" "}
                    <span>Water</span>
                  </h2>
                  <p>
                    Welcome to the Inaugural ACTnet Members Conference — a
                    global launchpad for the freight industry’s most driven
                    minds. Held in the dynamic city of Macau, this 3-day
                    experience unites logistics entrepreneurs, innovators, and
                    change-makers across our sub-networks from Asia to Arctic.
                  </p>
                  <p>
                    At this high-energy gathering, members will not only explore
                    the bold vision of ACTnet but also ignite deep partnerships,
                    access new tech tools, and co-create a freight-forwarding
                    ecosystem built on action, trust, and scalability.
                  </p>
                  <p>
                    From strategic panels and partner showcases to immersive
                    team-building and social networking, the ACTnet Global
                    Kick-Off is where momentum becomes movement.
                  </p>
                  {/* <form id="search" action="#" method="GET">
                    <fieldset>
                      <input
                        type="address"
                        name="address"
                        className="email"
                        placeholder="Your website URL..."
                        autocomplete="on"
                        required
                      />
                    </fieldset>
                    <fieldset>
                      <button type="submit" className="main-button">
                        Analyze Site
                      </button>
                    </fieldset>
                  </form> */}
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="right-image wow fadeInRight"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  {/* <h2>
                    Where <em>Fire Meets Ice,</em> and Ideas Flow Like{" "}
                    <span>Water</span>
                  </h2> */}
                  <img src="assets/images/benefits-2.jpg" alt="team meeting" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
